import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class CalendarService {

    year: any;
    yearChanged = new Subject<any>();
    month: any;
    monthChanged = new Subject<any>();
    agency: any;
    agencyChanged = new Subject<any>();

    setMonth(month: any) {
        this.month = month;
        this.monthChanged.next(this.month);
    }

    getMonth() {
        return this.month;
    }

    setYear(year: any) {
        this.year = year;
        this.yearChanged.next(this.year);
    }

    getYear() {
        return this.year;
    }

    setAgency(agency: any) {
        this.agency = agency;
        console.log("setAgency:" + this.agency);
        this.agencyChanged.next(this.agency);
    }

    getAgency() {
        return this.agency;
    }

}
